import CityPageTemplate from "../city-template/CityPageTemplate";
import { livoniaConfig } from "./data";

export default function LivoniaPage() {
  return <CityPageTemplate config={livoniaConfig} />;
}